import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import * as serviceWorker from './serviceWorker'
import 'bootstrap/dist/css/bootstrap.min.css'
import { usePromiseTracker } from 'react-promise-tracker'
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig, AuthProvider } from "./authProvider";
import { initializeAxiosInterceptor } from "./axiosAuthProvider";

const LoadingIndicator = () => {
  const { promiseInProgress } = usePromiseTracker();
  if (!promiseInProgress) return null;
  return (
    <div className="ef-loading-overlay">
      <div className="ef-loading__spinner" />
    </div>
  );
}

// Create and initialize MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL
msalInstance.initialize().then(() => {
  // Handle redirect promise after login
  return msalInstance.handleRedirectPromise();
}).then(() => {
  // Initialize axios interceptor with msalInstance
  initializeAxiosInterceptor(msalInstance);
  
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <App />
          <LoadingIndicator />
        </AuthProvider>
      </MsalProvider>
    </BrowserRouter>
  );
});
  

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
